import { ENABLED_AQUA } from '@openx/constants/feature-flag-keys';
import { ACL_TYPE } from '@openx/types/aclType';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isUserAllowedByAcl } from '@openx/utils/permission/validators';
import { Navigate, Outlet } from 'react-router';

export const AquaAccessGuard = () => {
  const { useIsAllowed, isGrowthbookFeatureOn } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  if (!isGrowthbookFeatureOn(ENABLED_AQUA) || !isAllowed(isUserAllowedByAcl(ACL_TYPE.AQUA_ENABLED))) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
